import { useSrpContext } from '@/src/contexts'
import { useTranslations } from 'next-intl'

import FareIntelligence from './fareIntelligence'

const FareIntelligenceWrapper = () => {
    const {
        SEOSrpData: { sections }
    } = useSrpContext()
    const t = useTranslations('common.routeSeoContent')

    const whenToBook = sections?.whenToBook
    if (!whenToBook?.fareOverview) return null

    const currency = whenToBook.fareSummary?.currency ?? 'SAR'
    const rawFares = whenToBook.monthlyBreakdown ?? []
    const maxFare = Math.max(...rawFares.map(f => f.avgFare), 1)

    const monthlyFares = rawFares.map(f => ({
        shortLabel: f.month.slice(0, 3),
        value: f.avgFare,
        heightPercent: (f.avgFare / maxFare) * 100,
    }))

    return (
        <FareIntelligence
            fareOverview={whenToBook.fareOverview}
            bookingAdvice={whenToBook.bookingAdvice}
            weekendVsWeekday={whenToBook.weekendVsWeekday}
            monthlyFares={monthlyFares}
            monthlyChartTitle={t('monthlyAverageFare')}
            monthlyUnit={t('perMonth', { currency })}
        />
    )
}

export default FareIntelligenceWrapper
